import * as React from 'react';

import Assets from "../../../../assets/img/assets";
import HeadlineMiddle from '../../../../common/atom/text/headline_middle';
import BtnCorporateLarge from '../../../../common/atom/btn/btn_corporate_large';
import styled from 'styled-components';
import HeadlineLarge from '../../../../common/atom/text/headline_large';
import {ConstBorderRound, ConstBreakPoint, ConstColor, ConstFontStyle} from 'src/config/styles_const/styles_const';
import HeadlineSmall from '../../../../common/atom/text/headline_small';
import {Customer} from 'src/domain/model/customer';
import BadgeNew from 'src/presentation/common/atom/badge/badge_new';

interface IProps {
    customer: Customer | null;
    handleNextStep: () => void;
}

export const CustomerTutorialMain: React.FC<IProps> = (props) => {

    const {
        customer,
        handleNextStep
    } = props;

    return(
        <TutorialWrapper>
            <BackgroundImg>
                <Img src={Assets.login}/>
            </BackgroundImg>
            <TutorialMainWrapper>
                {customer &&
                    <TutorialNameWrapper>
                        <TutorialTitle>{customer.name} 様</TutorialTitle>
                    </TutorialNameWrapper>
                }
                <TutorialTitleWrapper>
                    <TutorialTitle>エントリーありがとうございます！</TutorialTitle>
                </TutorialTitleWrapper>
                <TutorialBodyWrapper>
                    <TutorialSmall>当サービスのご利用には　</TutorialSmall>
                    <TutorialMiddle>EXPERT NETWORK運営局による審査の通過</TutorialMiddle>　
                    <TutorialSmall>　が必要です。</TutorialSmall>
                </TutorialBodyWrapper>

                <FunctionsListCardWrapper>
                    <ListTitleWrapper>
                        <ListTitle>審査通過で解放される機能一覧</ListTitle>
                    </ListTitleWrapper>
                    <ListsWrapper>
                        <ListTextWrapper>
                            <ListText icon={"'\f00c'"}>案件の閲覧</ListText>
                        </ListTextWrapper>
                        <ListTextWrapper>
                            <ListText icon={"'\f00c'"}>案件へのエントリー</ListText>
                        </ListTextWrapper>
                        <ListTextWrapper>
                            <ListText icon={"'\f00c'"}>スカウトの受信、メッセージのやりとり</ListText>
                        </ListTextWrapper>
                        <ListTextWrapper>
                            <ListText icon={"'\f00c'"}>ドメインブロック機能</ListText>
                        </ListTextWrapper>
                        <ListTextWrapper>
                            <ListText icon={"'\f00c'"}>バックオフィス管理ツールの無料使用</ListText>
                            <TutorialBadgeWrapper>
                                <BadgeNew>新機能！</BadgeNew>
                            </TutorialBadgeWrapper>
                        </ListTextWrapper>
                    </ListsWrapper>
                </FunctionsListCardWrapper>

                <BtnWrapper>
                    <TutorialBtn onClick={handleNextStep} widthSize={"200px"}>
                        面談調整をする
                    </TutorialBtn>
                </BtnWrapper>
            </TutorialMainWrapper>
        </TutorialWrapper>
    )

};

export default CustomerTutorialMain;

const TutorialWrapper = styled.div`
    position: relative;
    height: 820px;
    text-align: center;
`

const BackgroundImg = styled.div`
    width: 100%;
    opacity: 0.03;
    margin: auto;
    padding-top: 100px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        width: 65%;
        padding-top: 0px;
    };
`

const Img = styled.img`
`

const TutorialMainWrapper = styled.div`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        margin:0;
        padding:0;
    };
`

const TutorialNameWrapper = styled.div`
    margin-bottom: 20px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 30px;
    };
`

const TutorialTitleWrapper = styled.div`
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 50px;
    };
`

const TutorialTitle = styled(HeadlineLarge)`
    color: ${ConstColor.White};
    font-size: ${ConstFontStyle.SpTutorialLarge.fontSize};
    line-height: ${ConstFontStyle.SpTutorialLarge.lineHeight};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        font-size: ${ConstFontStyle.TutorialLarge.fontSize};
        line-height: ${ConstFontStyle.TutorialLarge.lineHeight};
    };
`

const TutorialBodyWrapper = styled.div`
    width: fit-content;
    margin: 0 auto 30px;
    display: block;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin: 0 auto 70px;
        display: flex;
    };
`

const TutorialSmall = styled(HeadlineSmall)`
    color: ${ConstColor.White};
`

const TutorialMiddle = styled(HeadlineMiddle)`
    color: ${ConstColor.Success};
`

const FunctionsListCardWrapper = styled.div`
    background-color: ${ConstColor.DeepBlack};
    border-radius: ${ConstBorderRound.AuthBorder};
    border: 1px solid ${ConstColor.Base};
    text-align: left;
    padding: 20px 15px 15px;
    width: 100%;
    margin: 0 auto 40px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        width: 570px;
        padding: 30px 70px;
    };
`

const ListTitleWrapper = styled.div`
    margin-bottom: 20px;
`

const ListTitle = styled(HeadlineMiddle)`
    color: ${ConstColor.White};
    margin: 0 auto;
    width: fit-content;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        font-size: ${ConstFontStyle.ValueLarge.fontSize};
        line-height: ${ConstFontStyle.ValueLarge.lineHeight};
    };
`

const ListsWrapper = styled.div`
`

const ListTextWrapper = styled.div`
    display: flex;
    margin-bottom: 15px;
`

const ListText = styled(HeadlineSmall)`
    color: ${ConstColor.White};
    font-size: ${ConstFontStyle.ParagraphSup.fontSize};
    :before {
        color: ${ConstColor.Success};
    };
`

const TutorialBadgeWrapper = styled.div`
    display: initial;
    margin-left: 15px;
    margin: auto;
`

const BtnWrapper = styled.div`
    text-align: center;
`

const TutorialBtn = styled(BtnCorporateLarge)`
    background-color: ${ConstColor.Success};
    color: ${ConstColor.Base};
    width: 200px;
    font-weight: ${ConstFontStyle.ValueLarge.fontWeight};
`


// WEBPACK FOOTER //
// ./src/presentation/component/customer/tutorial/main/customer_tutorial_main.tsx